export enum Errors {
  NO_NAME_ERROR = 'No name error',
  NETWORK_ERROR = 'Network error',
  API_BFF_ERROR = 'api/v3 ERROR',
  API_BE_ERROR = 'api/v2 ERROR',
}

export enum ErrorCodes {
  CANCELED = 'ERR_CANCELED',
  GUID_NOT_FOUND = 'guid_not_found',
  QUOTE_NOT_FOUND = 'quote_not_found',
  PAYMENT_LINKS_NOT_FOUND = 'payment_links_not_found',
  QUOTE_WITH_PROMOTION = 'quote_with_promotion',
}
